import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function DeleteEffort({
  isVisible,
  setIsVisible,
  client_id,
  trip_id,
  effortNr,
  handleAction,
}) {
  const [open, setOpen] = useState(isVisible);
  const content = `Please confirm delete Effort on this device. 
  This action cannot be undone!`;

  const handleCancel = (e) => {
    e.preventDefault();
    setOpen(false);
    setIsVisible(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsVisible(false);
    setOpen(false);
    handleAction(e);
  };

  return (
    <div>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Effort</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            autoFocus
            data-client_id={client_id}
            data-trip_id={trip_id}
            data-effort_id={effortNr ? effortNr : 0}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DeleteEffort;
